import React from 'react';

const AboutUs = () => (
  <>
    <style>{`
@font-face {
  font-family: 'CustomFont';
  src: url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff2'),
       url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'CustomFont', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #000;
  color: #fff;
}

/* Header (exactly like Home) */
header {
  background-color: #000;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  position: relative;      /* add this line */
}
  .buy-coffee {
  position: absolute;
  top: 20px;            /* lines up with header padding */
  right: 20px;
  color: #f5c65d;
  text-decoration: none;
  line-height: 1.1;
    font-size: 0.93rem;
  text-align: center;
  font-family: 'CustomFont', sans-serif;
}
/* Logo styling — adjust width as needed */
.header-logo {
  width: 250px;
  height: auto;
  /* Change the width above to resize the logo */
}

nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
nav a {
  color: #fff;
  text-decoration: none;
}
nav a:active {
  color: #f5c65d;
}
.social-links {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px; /* gap from nav */
}
.social-links a {
  color: #fdca05;
  text-decoration: none;
}

/* Main content wrapper */
main {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px 60px; /* bottom padding for scroll room */
}

/* Section styling */
main section {
  margin-bottom: 48px;
}
main h2 {
  color: #fdca05;
  text-align: center;
  margin-bottom: 16px;
  font-size: 2rem;
}
main p {
  margin-bottom: 24px;
  font-size: 1rem;
}

/* Owner blocks */
.owner-block {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}
.owner-image {
  flex-shrink: 0;
  width: 150px;
  border-radius: 8px;
}
.owner-bio {
  flex: 1;
}
.owner-bio h3 {
  color: #fdca05;
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 1.4rem;
}
.owner-bio p {
  font-size: 0.95rem;
  margin: 0;
}

/* Footer fixed to viewport bottom */
footer {
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 0px 0;
  position: fixed;
  font-size: 0.73rem;
  bottom: 0;
  width: 100%;
}

/* Responsive tweaks */
@media screen and (max-width: 600px) {
  main {
    margin: 20px auto;
    padding: 0 16px 40px;
  }
  nav {
    flex-wrap: wrap;
    gap: 10px;
  }
  .owner-block {
    flex-direction: column;
    align-items: center;
  }
  .owner-image {
    width: 120px;
    margin-bottom: 16px;
  }
  .owner-bio h3 {
    text-align: center;
  }
}
    `}</style>



    <main>
      <section>
        <h2>About</h2>
        <p>
          Rufus Johnson (born July 5, 1976), better known by his stage name Bizarre, formerly Bizarre Kid, is an American rapper and producer, best known for his work with the Detroit-based hip hop group D12.
        </p>
      </section>

      <section className="owner-block">
        <img
          src="/SF WEB IMAGES/profilepic.jpeg"
          alt="Lorenzo Cole"
          className="owner-image"
        />
        <div className="owner-bio">
          <h3>BIZARRE</h3>
          <p>
            His teacher thought he was talking to himself, and began calling him 'Bizarre Kid', which eventually led to the stage name 'Bizarre'. In 1995, he joined the rap group D12 with neighborhood friends DeShaun "Proof" Holton, Karnail "Bugz" Pitts, Carlos "Fuzz Scoota" Rabb, Willie "Eye Kyu" Drake, and Von "Kuniva" Carlisle. He also met Marshall "Eminem" Mathers through Proof. Bizarre used to attend a club on Friday nights called 'The Shelter' in Saint Andrew's Hall, where rap battles were held.
          </p>
        </div>
      </section>
    </main>

    <footer>
      <p>&copy; 2025 Street Flavor Records / SPNDAT INC. All rights reserved.</p>
    </footer>
  </>
);

export default AboutUs;
